export enum AuthContext {
    Payments = 'Payments',
}
